import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router';
import { urlModifier } from 'swag-client-common/libs/url-modifier';
import { CategoryLink } from '../category-link';
import { SubcategoriesLinks } from '../subcategories-links';
import classes from './categories-links.scss';
const ESCAPE_KEY = 'Escape';
const ARROW_UP_KEY = 'ArrowUp';
const ARROW_DOWN_KEY = 'ArrowDown';
const SPACE_KEY = ' ';
export function CategoriesLinksComponent({
  categories,
  currentRoute,
  onLinkClick,
  currentSubcategoryId,
  currentMainCategory,
  isViolet,
  isShadowDisabled,
  isFilterOpened,
  allSubcategories
}) {
  const [allSwag, ...rest] = categories;
  const [hoverCategoryId, setHoverCategoryId] = React.useState(null);
  const [lastFocusedCategory, setLastFocusedCategory] = React.useState(null);
  const [isFirstFocused, setIsFirstFocused] = React.useState(false);
  const handleMouseEnter = e => {
    const id = e.currentTarget.dataset.id;
    setHoverCategoryId(id);
  };
  const handleSubcategoriesClick = () => {
    setHoverCategoryId(null);
    onLinkClick();
  };
  const handleFocus = event => {
    setLastFocusedCategory(event.currentTarget);
    handleMouseEnter(event);
  };
  const handleReturnFocusBack = event => {
    if (event.key === ESCAPE_KEY || event.key === ARROW_UP_KEY || event.key === SPACE_KEY) {
      setIsFirstFocused(false);
      if (lastFocusedCategory) {
        lastFocusedCategory.focus();
      }
    }
  };
  const handleKeyPress = event => {
    if (event.key === ARROW_DOWN_KEY || event.key === SPACE_KEY) {
      setIsFirstFocused(true);
      event.preventDefault();
    } else {
      setIsFirstFocused(false);
    }
  };
  const hoverCategory = categories === null || categories === void 0 ? void 0 : categories.find(({
    _id
  }) => hoverCategoryId === _id);
  const activeCategory = hoverCategory || currentMainCategory;
  const isLogoCategory = activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.isLogoCategory;
  const isOneline = currentMainCategory.isLogoCategory && !(hoverCategory !== null && hoverCategory !== void 0 && hoverCategory.isLogoCategory);
  const handleMouseLeave = () => {
    setHoverCategoryId(null);
  };
  if (!allSwag || !rest) {
    return null;
  }
  return /*#__PURE__*/React.createElement("nav", {
    className: classnames(classes.menu),
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/React.createElement(Link, {
    key: allSwag._id,
    to: currentRoute ? urlModifier(`${currentRoute}/${allSwag.link}`) : urlModifier(`/${allSwag.link}`),
    onClick: () => !allSwag.isActive && onLinkClick && onLinkClick(),
    className: classnames(classes.menuItem, {
      [classes.activeMenuItem]: allSwag.isActive || hoverCategoryId === allSwag._id,
      [classes.violet]: isViolet
    }),
    onKeyDown: handleKeyPress,
    "data-id": allSwag._id,
    onFocus: handleFocus
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.linkName
  }, /*#__PURE__*/React.createElement("span", {
    onMouseEnter: handleMouseEnter,
    "data-id": allSwag._id,
    className: classes.text
  }, allSwag.name))), /*#__PURE__*/React.createElement("div", {
    className: classes.links
  }, rest.map(category => {
    return /*#__PURE__*/React.createElement(CategoryLink, {
      key: category._id,
      category: category,
      isViolet: isViolet,
      currentRoute: currentRoute,
      onLinkClick: onLinkClick,
      handleMouseEnter: handleMouseEnter,
      hoverCategoryId: hoverCategoryId,
      onKeyDown: handleKeyPress,
      onFocus: handleFocus
    });
  })), /*#__PURE__*/React.createElement(SubcategoriesLinks, {
    isViolet: isViolet,
    currentRoute: currentRoute,
    subcategories: activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.subcategories,
    parentCategory: activeCategory,
    currentMainCategory: currentMainCategory,
    currentSubcategoryId: currentSubcategoryId,
    isFilterOpened: isFilterOpened,
    onLinkClick: handleSubcategoriesClick,
    wrapperClassName: classnames({
      [classes.withoutShadow]: isShadowDisabled,
      [classes.isFilterOpened]: isFilterOpened
    }),
    isLogoCategory: isLogoCategory,
    isOneline: isOneline,
    handleMouseEnter: handleMouseEnter,
    allSubcategories: allSubcategories,
    isFirstFocused: isFirstFocused,
    onKeyDown: handleReturnFocusBack
  }));
}